import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetTeamAiIdentity as GetTeamAiIdentityQuery,
    GetTeamAiIdentity_teamAiIdentity as TeamAiIdentity,
    GetTeamAiIdentity_loggedInUser as User,
} from 'nutshell-graphql-types';

import GET_TEAM_AI_IDENTITY from '../queries/get-team-ai-identity.graphql';

export const useGetTeamAiIdentity = (): {
    userIdentity:
        | {
              teamAiIdentity: TeamAiIdentity;
              loggedInUser: User;
          }
        | null
        | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetTeamAiIdentityQuery, Record<any, any>>(
        GET_TEAM_AI_IDENTITY
    );

    return {
        userIdentity: data,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
